import './DashboardPage.css';

import React, { Component, createRef } from 'react';
import { InputSwitch } from "primereact/inputswitch";

import Common from '../../module/Common';
import ManagerContext from '../../context/ManagerContext';
import { UtilsService } from '../../services/UtilsService';
import { ApiService } from '../../services/ApiService';
import { BroadcastService } from '../../services/BroadcastService';
import { DashboardService } from '../../services/DashboardService';

import { ActiveJobsByDriver } from '../../components/ActiveJobsByDriver';
import { ActiveRoutes } from '../../components/ActiveRoutes';
import { ActiveJobs } from '../../components/ActiveJobs';
import { MapPane } from '../../components/MapPane';
import { TogglePanel } from '../../components/TogglePanel';



export class DashboardPage extends Component {

    static displayName = DashboardPage.name;
    
    utilsService = new UtilsService();
    apiService = new ApiService();
    broadcastService = new BroadcastService();
    dashboardService = new DashboardService();

    mapPaneRef = createRef();
    activeJobsByDriverRef = createRef();
    // activeJobsRef = createRef();
    loadActiveJobsInterval;
    loadActiveRoutesInterval;


    constructor(props, context) {
        super(props, context);
        
        this.state = {
            activeJobs: [], 
            activeRoutes: [], 
            drivers: [],
            driverNumberFilter: null,
            expandedDriver: null, /* Driver data of the expanded driver row, this should include the today's completedJobs */
            loadingActiveJobs: false, 
            loadingActiveRoutes: false, 
            isActiveJobsGroupedByDriver: false
        };
    }


    get viewIsSmallerThanLaptop() {
        return window.innerWidth <= 1200;
    }
    
    
    componentDidMount() {
        setTimeout(() => {
            this.loadData();
            this.loadActiveJobsWithInterval();
            this.loadActiveRoutesWithInterval();
        })
        
        this.broadcastService.registerObserver('clientCodeOrStateSelected', () => {
            ApiService.activeJobs = [];
            ApiService.activeRoutes = [];
            this.loadData();
        })
    }


    componentWillUnmount() {
        clearInterval(this.loadActiveJobsInterval);
        clearInterval(this.loadActiveRoutesInterval);
        this.broadcastService.unregisterObserver('clientCodeOrStateSelected');
    }


    get mapData() {
        const data = {
            activeJobs: this.state?.activeJobs,
            drivers: this.state?.drivers.filter(driver=> driver.id !== null),
            hideActiveJobMarkers: true,
        };

        if(this.state?.expandedDriver) {
            data.activeJobs = this.state?.activeJobs?.filter(job => job.driverDetail?.driverId == this.state?.expandedDriver?.driverNumber);
            data.drivers = this.state?.drivers?.filter(driver => driver.id == this.state?.expandedDriver?.driverNumber);
            data.hideActiveJobMarkers = false;
        }
        
        return data;
    }


    loadData() {
        this.setState({ loadingActiveJobs: true });
        this.loadActiveJobs();
        this.setState({ loadingActiveRoutes: true });
        this.loadActiveRoutes();
    }


    loadActiveJobs() {
        this.apiService.loadActiveJobs(this.context.SelectedStateId, this.context.SelectedClientCode)
        .then(activeJobs => {
            const drivers = this.dashboardService.getDriversFromActiveJobs(activeJobs);
            this.setState(
                { activeJobs: activeJobs, drivers: drivers },
                () => {
                    if(this.activeJobsByDriverRef?.expandByDriverNumber) {
                        this.activeJobsByDriverRef?.expandByDriverNumber(this.state?.expandedDriver?.driverNumber);
                    }
                }
            );
        })
        .finally(() => {
            this.setState({ loadingActiveJobs: false });
        });
    }


    loadActiveRoutes() {
        // Run only for Sigma related accounts.
        if(this.utilsService?.isClientCodeSigmaRelated(this.context?.SelectedClientCode)) {
            this.apiService.loadActiveRoutes(this.context.SelectedStateId, this.context.SelectedClientCode)
            .then(activeRoutes => {
                this.setState({ activeRoutes: activeRoutes });
            })
            .finally(() => {
                this.setState({ loadingActiveRoutes: false });
            });
        }
    }


    loadActiveJobsWithInterval() {
        this.loadActiveJobsInterval = setInterval(() => {
            ApiService.activeJobs = []; /* Clear first the cached activeJobs data */
            this.loadActiveJobs();
        }, Common.getRefreshTime());
    }


    loadActiveRoutesWithInterval() {
        this.loadActiveRoutesInterval = setInterval(() => {
            ApiService.activeRoutes = []; /* Clear first the cached activeRoutes data */
            this.loadActiveRoutes();
        }, Common.getRefreshTime());
    }
    
    
    recenterMap(lat, lng) {
        this.mapPaneRef.centerMapByCoordinates(lat, lng);
    }


    recenterMapByDriverNumber(driverNumber) {
        this.mapPaneRef.centerMapByDriverNumber(driverNumber);
    }


    toggleActiveJobsMode(value) {
        this.setState({
            isActiveJobsGroupedByDriver: value,
            driverNumberFilter: null,
            expandedDriver: null,
        })
    }


    /**
     * Render ActiveRoutes if the logged in account is Sigma related.
     * Else we render ActiveJobs
     */
    renderActiveJobs() {
        if(this.utilsService?.isClientCodeSigmaRelated(this.context?.SelectedClientCode)) {
            return <ActiveRoutes 
                activeRoutes={this.state?.activeRoutes} 
                loadingActiveRoutes={this.state?.loadingActiveRoutes} 
                driverNumber={this.state?.driverNumberFilter}
                driverNumberFilterChanged={
                    (driverNumber) => {
                        this.setState({ driverNumberFilter: driverNumber });
                    }
                }
                activeRouteSelected={(activeRoute) => {
                    this.recenterMapByDriverNumber(activeRoute.driver);
                    this.setState({ driverNumberFilter: activeRoute.driver });
                }}
            ></ActiveRoutes>
        }
        
        else {
            if(this.state?.isActiveJobsGroupedByDriver) {
                const activeJobsByDriverScrollable = this.viewIsSmallerThanLaptop ? false : true;
                return <ActiveJobsByDriver 
                    ref={(e) => this.activeJobsByDriverRef = e}
                    activeJobs={this.state?.activeJobs} 
                    loadingActiveJobs={this.state?.loadingActiveJobs}
                    scrollable={activeJobsByDriverScrollable} 
                    driverNumber={this.state?.driverNumberFilter}
                    driverNumberFilterChanged={
                        (driverNumber) => {
                            this.setState({ driverNumberFilter: driverNumber });
                        }
                    }
                    jobSelected={
                        (job) => { 
                            this.setState({ driverNumberFilter: job?.driverNumber ?? null, expandedDriver: null });
                            this.activeJobsByDriverRef?.collapseAllRows();
                            setTimeout(() => this.recenterMapByDriverNumber(job?.driverNumber))
                        }
                    }
                    driverExpanded={
                        (driver) => {
                            if(driver) {
                                this.setState({ expandedDriver: driver, driverNumberFilter: driver?.driverNumber });
                            } else {
                                this.setState({ expandedDriver: null, driverNumberFilter: null })
                            }
                        }
                    }
                ></ActiveJobsByDriver>
            }

            else {
                const activeJobsScrollable = this.viewIsSmallerThanLaptop ? false : true;
                return <ActiveJobs
                    ref={(e) => this.activeJobsRef = e}
                    activeJobs={this.state?.activeJobs}
                    loadingActiveJobs={this.state?.loadingActiveJobs}
                    scrollable={activeJobsScrollable}
                    showDriverNumberFilter={true}
                    driverNumber={this.state?.driverNumberFilter}
                    driverNumberFilterChanged={
                        (driverNumber) => {
                            this.setState({ driverNumberFilter: driverNumber });
                        }
                    }
                    jobSelected={
                        (job) => { 
                            this.setState({ driverNumberFilter: job?.driverNumber ?? null, expandedDriver: null });
                            setTimeout(() => this.recenterMapByDriverNumber(job?.driverNumber))
                        }
                    }
                ></ActiveJobs>
            }
        }
    }


    renderActiveJobsModeSwitch() {
        if(this.state?.loadingActiveJobs || !this.state?.activeJobs?.length) {
            return null;
        }

        else {
            return <div className="active-jobs-mode-switch flex flex-row gap-2 justify-content-center align-items-center m-2">
                <InputSwitch checked={this.state.isActiveJobsGroupedByDriver} onChange={(e) => this.toggleActiveJobsMode(e.value)} />
                <div className="label" onClick={() => this.toggleActiveJobsMode(!this.state?.isActiveJobsGroupedByDriver)}>Group By Driver</div>
            </div>
        }
    }
    
    
    render() {
        let context = this.context;

        if (context.IsLoggedIn) {
            return (
                <div className="dashboard-page flex flex-column gap-5 xl:flex-row xl:gap-2">
                    <div className="active-jobs-container w-full xl:w-6">
                        {this.renderActiveJobsModeSwitch()}
                        {this.renderActiveJobs()}
                    </div>

                    <div className="flex flex-column w-full xl:w-6">
                        <div className="map-container">
                            <MapPane 
                                ref={(e) => this.mapPaneRef = e} 
                                activeJobs={this.mapData?.activeJobs}
                                activeRoutes={this.state?.activeRoutes} 
                                drivers={this.mapData?.drivers}
                                completedJobs={this.state?.expandedDriver?.completedJobs ?? []}
                                hideActiveJobMarkers={this.mapData?.hideActiveJobMarkers}
                                hideLegendContainer={this.state?.expandedDriver ? false : true}
                                hideLegendSelectedJob={true}
                            ></MapPane>
                        </div>

                        <TogglePanel 
                            driverNumber={this.state?.driverNumberFilter} 
                            driverNumberFilterChanged={
                                (driverNumber) => {
                                    this.setState({ driverNumberFilter: driverNumber });
                                }
                            }
                            jobSelected={
                                (job) => {
                                    this.setState({ driverNumberFilter: job?.driverNumber ?? null, expandedDriver: null });
                                    setTimeout(() => this.recenterMapByDriverNumber(job?.driverNumber));
                                    
                                    if(this.activeJobsByDriverRef?.collapseAllRows) {
                                        this.activeJobsByDriverRef?.collapseAllRows();
                                    }
                                }
                            }
                        ></TogglePanel>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="dashboard-page">
                    Please ensure that you are logged in
                </div>
            );
        }
  }
}

DashboardPage.contextType = ManagerContext;
